export default __webpack_public_path__ + "static/media/eternit.2c6876a4.png";